import React, { useState } from 'react';
import { TeamSearch as NYYTeamSearch } from 'yankees-react-utils';
import { Search as searchData, useOktaQuery } from '../data';

const TeamSearch = (props) => {
    const [criteria, setCriteria] = useState();
    const [shouldDoFetch, setShouldDoFetch] = useState(false);
    const { data, isLoading, remove } = useOktaQuery(
        ['search-teams', criteria],
        (t) => searchData.teams(t, { criteria }),
        { enabled: shouldDoFetch },
    );

    const search = (searchCriteria, shouldFetch) => {
        setCriteria(searchCriteria);
        setShouldDoFetch(shouldFetch);
    };
    const onHide = () => {
        setShouldDoFetch(false);
        remove();
    };

    return (
        <NYYTeamSearch search={search} isLoading={isLoading} results={data} onHide={onHide} {...props} />
    );
};

TeamSearch.propTypes = {};

export default TeamSearch;
